import { css } from '@firebolt-dev/css'

export function Logo() {
  return (
    <svg
      width='180'
      height='180'
      viewBox='0 0 180 180'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      css={css`
        path {
          fill: #000;
        }
        @media (prefers-color-scheme: dark) {
          path {
            fill: #fff;
          }
        }
      `}
    >
      <path d='M133 89.9991L90 132.999L47 89.9991L90 46.9991L133 89.9991ZM64.9167 89.9991L90 115.082L115.083 89.9991L90 64.9158L64.9167 89.9991Z' />
      <path d='M176 90L90 176L4 90L90 4L176 90ZM21.9167 90L90 158.083L158.083 90L90 21.9167L21.9167 90Z' />
      <path d='M136.583 68.4992L145.542 77.4575L133 89.9991L124.042 81.0409L136.583 68.4992Z' />
      <path d='M47 89.9991L55.9583 98.9577L43.4166 111.499L34.4583 102.541L47 89.9991Z' />
    </svg>
  )
}
